import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import AdminRoute from './auth/AdminRoute';

import LoginSignup from './Components/LoginSignup/LoginSignup.jsx';
import HomePage from './Components/HomePage/HomePage.jsx';
import Dashboard from './Components/Dashboard/Dashboard.jsx';
import ChildDetails from './Components/ChildRegistration/ChildDetails.jsx';
import FamilyDetails from './Components/ChildRegistration/FamilyDetails.jsx';
import ReviewAndFinish from './Components/ChildRegistration/ReviewAndFinish.jsx';
import Profiles from './Components/Profiles/Profiles.jsx';
import ArchivedProfiles from './Components/Profiles/ArchivedProfiles.jsx';
import ChildProfile from './Components/ChildProfile/ChildProfilePage.jsx';
import ChildProfileLayout from './Components/ChildProfile/ChildProfileLayout.jsx';
import Vaccination from './Components/ChildProfile/Vaccination.jsx';
import Growth from './Components/ChildProfile/Growth.jsx';
import Milestones from './Components/ChildProfile/Milestones.jsx';
import Layout from './Components/Layout/Layout.jsx';
import Report from './Components/Reports/Report.jsx';
import VaccineSummaries from './Components/Reports/VaccineSummaries.jsx';
import ChildRegistrationReport from './Components/Reports/ChildRegistrationReport.jsx';
import GrowthMonitoringReport from './Components/Reports/GrowthMonitoringReport.jsx';
import UpcomingVaccinationsReport from './Components/Reports/UpcomingVaccinationsReport.jsx';
import RapidEntry from './Components/RapidEntry/RapidEntry.jsx';
import Reminders from './Components/Reminders/Reminders.jsx';
import Help from './Components/Help/Help.jsx';
import AdminDashboard from './Components/Admin/AdminDashboard.jsx';
import AdminHelpMessages from './Components/Admin/AdminHelpMessages.jsx';
import AdminHelpMessageDetail from './Components/Admin/AdminHelpMessageDetail.jsx';
import AdminUsers from './Components/Admin/AdminUsers.jsx';
import AdminCreateUser from './Components/Admin/AdminCreateUser.jsx';
import AdminVaccines from './Components/Admin/AdminVaccines.jsx';

// Index dispatcher: /vaccination/22, /growth/22, etc. deep-link to the
// matching tab page; anything else falls back to the child profile.
function TabIndex() {
    const { tab } = useParams();
    if (tab === 'vaccination') return <Vaccination />;
    if (tab === 'growth') return <Growth />;
    if (tab === 'milestones') return <Milestones />;
    return <ChildProfile />;
}

function App() {
    return (
        <Router>
            <AuthProvider>
                <div className="App">
                    <Routes>
                        <Route path="login" element={<LoginSignup />} />

                        {/* Routes that need the sidebar in the Layout component */}
                        <Route element={<Layout />}>
                            <Route path="/" element={<Navigate to="/dashboard" replace />} />
                            <Route path="/add-child" element={
                                <ProtectedRoute><ChildDetails /></ProtectedRoute>
                            } />
                            <Route path="/family-details" element={
                                <ProtectedRoute><FamilyDetails /></ProtectedRoute>
                            } />
                            <Route path="/review-and-finish" element={
                                <ProtectedRoute><ReviewAndFinish /></ProtectedRoute>
                            } />
                            <Route path="/rapid-entry" element={
                                <ProtectedRoute><RapidEntry /></ProtectedRoute>
                            } />
                            <Route path="/home" element={
                                <ProtectedRoute><HomePage /></ProtectedRoute>
                            } />
                            <Route path="/dashboard" element={
                                <ProtectedRoute><Dashboard /></ProtectedRoute>
                            } />
                            <Route path="/profiles" element={
                                <ProtectedRoute><Profiles /></ProtectedRoute>
                            } />
                            <Route path="/profiles/archived" element={
                                <AdminRoute><ArchivedProfiles /></AdminRoute>
                            } />
                            <Route path="/:tab/:id" element={
                                <ProtectedRoute><ChildProfileLayout /></ProtectedRoute>
                            }>
                                <Route index element={<TabIndex />} />
                                <Route path="profile" element={<ChildProfile />} />
                                <Route path="vaccination" element={<Vaccination />} />
                                <Route path="growth" element={<Growth />} />
                                <Route path="milestones" element={<Milestones />} />
                            </Route>
                            <Route path="/reports" element={
                                <ProtectedRoute><Report /></ProtectedRoute>
                            } />
                            <Route path="/reports/vaccine-summaries" element={
                                <ProtectedRoute><VaccineSummaries /></ProtectedRoute>
                            } />
                            <Route path="/reports/child-registration" element={
                                <ProtectedRoute><ChildRegistrationReport /></ProtectedRoute>
                            } />
                            <Route path="/reports/growth-monitoring" element={
                                <ProtectedRoute><GrowthMonitoringReport /></ProtectedRoute>
                            } />
                            <Route path="/reports/upcoming-vaccinations" element={
                                <ProtectedRoute><UpcomingVaccinationsReport /></ProtectedRoute>
                            } />
                            <Route path="/reminders" element={
                                <ProtectedRoute><Reminders /></ProtectedRoute>
                            } />
                            <Route path="/help" element={
                                <ProtectedRoute><Help /></ProtectedRoute>
                            } />
                            <Route path="/vaccination" element={
                                <ProtectedRoute><AdminVaccines /></ProtectedRoute>
                            } />
                            <Route path="/admin/vaccines" element={
                                <Navigate to="/vaccination" replace />
                            } />
                            <Route path="/admin" element={
                                <AdminRoute><AdminDashboard /></AdminRoute>
                            } />
                            <Route path="/admin/messages" element={
                                <AdminRoute><AdminHelpMessages /></AdminRoute>
                            } />
                            <Route path="/admin/messages/:id" element={
                                <AdminRoute><AdminHelpMessageDetail /></AdminRoute>
                            } />
                            <Route path="/admin/users" element={
                                <AdminRoute><AdminUsers /></AdminRoute>
                            } />
                            <Route path="/admin/users/new" element={
                                <AdminRoute><AdminCreateUser /></AdminRoute>
                            } />
                        </Route>
                    </Routes>
                </div>
            </AuthProvider>
        </Router>
    );
}

export default App;
